<template lang="pug">
	.linked-company-name.flex-row.space.align-center(v-if="company", :title="hint")
		Loader(v-if="isLoading")
		.small(v-if="!company.IsUserAssigned")
			DxButton(icon="fas fa-user-plus", @click="inviteContacts")
		.company-name(:class="{ 'no-users': !company.IsUserAssigned }", :data-unlinked-text="$tCaption('No contacts')", @click="inviteContacts") {{company.Name}}
		CompanySelector(ref="companySelector", :dropdownVisible="false", @inviting="() => isLoading = true", @invited="onInvited")
</template>

<script>
	import CompanySelector from 'view/company/CompanySelector.vue';
	import Loader from 'app-core/Loader.vue';
	import VueTypes from 'vue-types';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'company.LinkedCompanyName',
		components: { CompanySelector, DxButton, Loader },
		name: 'linked-company-name',
		props: {
			company: VueTypes.any.def(null)
		},
		data() {
			return {
				isLoading: false
			}
		},
		computed: {
			hint() {
				return `${this.company.Name} ${this.$tCaption('doesn’t have any registered contacts on the Adthos platform. Would you like to invite a contact at', '@company-selector')} ${this.company.Name}?`;
			}	
		},
		methods: {
			inviteContacts() {				
				this.$refs.companySelector.inviteContactToCompany(this.company);
			},
			onInvited(v) {
				this.isLoading = false;
				if (v)
					this.$emit('invited');
			}
		}
	};
</script>
<style lang='scss'>
	.linked-company-name {
		> .company-name {
			&.no-users {
				color: #f00;
				position: relative;
				cursor: pointer;

				&:hover {
					color: #f99;
				}

				&:after {
					content: attr(data-unlinked-text);
					position: absolute;
					left: 0px;
					bottom: -16px;
					font-size: 10px;
				}
			}
		}
	}
</style>
 